import React, { useEffect, useState } from "react";

import ViewCard from "../../common/ViewCard/ViewCard";
import { handleCatch, mapArraysWithTitle } from "../../../shared/helpers";
import APIVariables from "../../../services/api-variables";
import Axios from "../../../services/Axios";

const ReportEvent = () => {
  const [patientsBrochures, setPatientsBrochures] = useState([]);
  const [pharmacyList, setPharmacyList] = useState([]);

  useEffect(() => {
    getBrochures();
    getPharmacyList();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getBrochures = async () => {
    const res = await Axios.get(APIVariables.PATIENTS_ADVERSE_EVENTS).catch(
      (error) => {
        handleCatch(error);
      }
    );

    setPatientsBrochures(res.data);
  };

  const getPharmacyList = async () => {
    const res = await Axios.get(
      APIVariables.ORDERS_MAH_REPORT_ADVERSE_EVENTS
    ).catch((error) => {
      handleCatch(error);
    });

    setPharmacyList(res.data);
  };

  const mappedData = mapArraysWithTitle(patientsBrochures);

  return (
    <main
      className="min-h-screen w-full overflow-y-auto bg-[#f8f8f8] px-4 pb-16 pt-16"
      data-testid="report-event-page"
    >
      <div className="mx-auto w-full max-w-[600px] min-[851px]:max-w-[800px] min-[1201px]:max-w-[1100px]">
        <h1
          className="text-2xl font-semibold leading-tight text-[#00567a]"
          data-testid="report-event-heading"
        >
          Report an Adverse Event and/or Pregnancy
        </h1>

        <p
          className="mt-5 text-justify text-base leading-relaxed text-[#374151]"
          data-testid="report-event-intro"
        >
          Adverse Events and cases of suspected or confirmed pregnancy or foetal
          exposure should be reported. Adverse Event Report forms and Pregnancy
          Reporting forms can be found below and should be forwarded to the
          relevant Marketing Authorisation Holder.
        </p>

        <section
          className="mb-2 pt-12 sm:pt-14"
          data-testid="report-event-forms"
        >
          <div className="flex flex-col">
            {(mappedData || []).map((item, index) => (
              <article
                key={index}
                className="mt-10 first:mt-0 sm:mt-12 sm:first:mt-0"
                data-testid={`report-event-form-section-${index}`}
              >
                <hr className="border-gray-300" />
                <h2 className="my-8 w-full text-xl font-bold text-[#00567a] sm:text-2xl">
                  {item.title}
                </h2>
                <ViewCard
                  pharmacyList={pharmacyList}
                  brochure={item}
                  displayImage={false}
                  displayTitle={true}
                  isReportanAdverseEventPage={true}
                />
              </article>
            ))}
          </div>
        </section>

        <p
          className="mb-2 mt-10 text-justify text-base leading-relaxed text-[#374151] sm:mr-5"
          data-testid="report-event-yellow-card"
        >
          Adverse events can also be reported online via the Yellow Card website{" "}
          <a
            href="https://yellowcard.mhra.gov.uk/"
            className="text-[#646464] underline decoration-[#646464] underline-offset-2 transition-colors hover:text-[#374151]"
            target="_blank"
            rel="noreferrer"
            data-testid="report-event-yellow-card-link"
          >
            https://yellowcard.mhra.gov.uk/
          </a>{" "}
          or search for MHRA Yellow Card in the Google Play or Apple App Store.
          Alternatively, prepaid Yellow Cards for reporting are available:
        </p>

        <ul className="ml-6 list-disc space-y-1 text-justify text-base leading-snug text-[#374151]">
          <li>
            by writing to FREEPOST YELLOW CARD (no other address details
            necessary);
          </li>
          <li>by emailing yellowcard@mhra.gov.uk;</li>
          <li>
            by telephoning the Commission on Human Medicines (CHM) free phone
            line: 0800-731-6789;
          </li>
          <li>
            or by downloading and printing a form from the Yellow Card section of
            the MHRA website.
          </li>
        </ul>
      </div>
    </main>
  );
};
export default ReportEvent;
